import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=b2eb84d8&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"
import style0 from "./Callback.vue?vue&type=style&index=0&id=b2eb84d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eb84d8",
  null
  
)

export default component.exports